import { initialState } from "./state";

export const contactUs = (state = initialState, action) => {
  switch (action.type) {
    case "SET_CONTACT_US_LIST": {
      return Object.assign({}, state, {
        contactUsList: action.data
      });
    }
    case "SET_ACTIVE_CONTACT_US": {
      return Object.assign({}, state, {
        activeContactUs: action.data
      });
    }
    default:
      return state;
  }
};
